<template>
  <div class>
    <!-- dont use buggy type="number" -->
    <input
      class="form-control form-control-sm e2e-real-field e2e-numeric-field"
      v-mc-validate="validatorArgs"
      :style="{'max-width': width, 'min-width': width}"
      v-model="value"
      :placeholder="fragment.placeholder"
      :name="fragment.uuid"
      :readonly="!fragment.editable"
    >

    <div
      v-if="validationErrorMessage"
      class="invalid-feedback text-right"
    >{{validationErrorMessage}}</div>
  </div>
</template>

<script>
import "../utils.js"; // v-mc-validate directive

export default {
  name: "fragment-real-field",
  props: ["fragment"],
  data: function() {
    return {
      validationErrorMessage: null,
      value: null
    };
  },
  methods: {
    onValidationChanged({ errorMessage }) {
      this.validationErrorMessage = errorMessage;
    }
  },
  mounted() {
    this.value = this.fragment.initialValue;
  },
  computed: {
    validatorArgs() {
      return {
        expect: "real",
        from: this.fragment.rangeFrom,
        to: this.fragment.rangeTo,
        allowNoValue: this.fragment.allowNoValue,
        onValidationChanged: this.onValidationChanged, // callback
        semanticValidation: {
          invalid: this.fragment.semanticInvalid,
          validatedValue: this.fragment.initialValue,
          message: this.fragment.semanticInvalidMessage
        }
      };
    },
    width() {
      if (this.fragment.widthPixel) {
        return `${this.fragment.widthPixel}px`;
      }
      return "initialValue";
    }
  }
};
</script>
 

<style scoped>
</style>